module.exports = __webpack_public_path__ + "static/media/YB5M09_0.b78aa83d.jpg";